import { useMemo, useRef } from 'react';

export const useSortedMetricsMemo = ({ metrics, sortBy }) => {
  const _sortByRef = useRef(null);
  _sortByRef.current = sortBy;

  return useMemo(() => {
    if (_sortByRef.current) {
      return [...metrics].sort((a, b) => {
        return _sortByRef.current(a.sortKey, b.sortKey);
      });
    }
    return metrics;
  }, [metrics]);
};
